import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
//import useStyles from './Styles';
import loading from './loading.svg';
import "./Loading.scss";

interface Props {
	isLoading:boolean,
}

const Loading:React.FC<Props> = (props)=> {
	if(!props.isLoading){
		return (null);
	}
	//const classes = useStyles();
	return (
		<div id="loading" className="loading">
			<span className="spinner"><CircularProgress size="6em"/></span>
		</div>
    );
}

export default Loading;
